import { Factory, trait } from 'miragejs';
import { faker } from '@faker-js/faker';

faker.seed(1);

export default Factory.extend({
	name: () => faker.person.firstName(),
	rememberToken: () => faker.string.uuid(),
	authToken: () => faker.string.uuid(),
	userId: 'C00',
	password: '123456',
	loginErrorCount: 0,
	state: 'ACTIVE',
	blocked: trait({
		state: 'BLOCKED',
	}),
});
